export const states = [
  { label: 'On', value: true },
  { label: 'Off', value: false },
];

export const options = [
  { label: 'GMB Reminders (before the activity):', key: 'intention' },
  { label: 'GMB Check-Ins (after the activity):', key: 'checkin' },
];
